import React, { Component } from 'react'
import { AvtarImgs, InsightRowData, InsightTitle, ListData, ListImage, ListName, ProfileDivs, UserNames } from '../styles/main'

class ContactLeftPartTheme extends Component {

    renderMessageData(img, name, number, total) {
        return (
            <ListData>
                <div className='d-flex align-items-center'>
                    <ListImage>
                        <img src={img} />
                    </ListImage>
                    <ListName>
                        {name}
                        <div>{number}</div>
                    </ListName>
                </div>
                {/* <span className='active-sign'><Icon icon="edit"></Icon></span> */}
                {/* {this.renderActionBar(this.props.custInfo.info)} */}
                <div className='actions_numbers'>
                    <span>
                        {total}
                    </span>
                </div>
            </ListData>
        )
    }

    render() {
        return (
            <InsightRowData className='fixLeftPart'>
                <ProfileDivs style={{justifyContent: 'space-around'}}>
                    <AvtarImgs>
                        <img src="/images/LoginAgent.png" />
                    </AvtarImgs>
                    <UserNames>
                        Leonard	Campbell
                        <div>Sales</div>
                    </UserNames>
                    {/* <span className='active-sign'><Icon icon="edit"></Icon></span> */}
                    {/* {this.renderActionBar(this.props.custInfo.info)} */}
                    {/* <div className='actions'> */}
                        <span class="material-symbols-outlined">
                            more_vert
                        </span>
                    {/* </div> */}
                </ProfileDivs>
                <div className='p-3'>
                    <div className='box-title'>
                        <InsightTitle>
                            DIRECT MESSAGE
                        </InsightTitle>
                        <span class="material-symbols-outlined">
                            add
                        </span>
                    </div>
                </div>
                <div style={{ height: '200px', overflowY: 'auto' }}>
                    {this.renderMessageData(
                        '/images/LoginAgent.png',
                        'Christopher Lyman',
                        '+91 980-798-8989',
                        '04'
                    )}
                    {this.renderMessageData(
                        '/images/LoginAgent.png',
                        'Campbell',
                        '+91 980-798-8989',
                        '22'
                    )}
                    {this.renderMessageData(
                        '/images/LoginAgent.png',
                        'Tracey	Simpson',
                        '+91 980-798-8989',
                        '17'
                    )}
                    {this.renderMessageData(
                        '/images/LoginAgent.png',
                        'Christopher Lyman',
                        '+91 980-798-8989',
                        '12'
                    )}
                    {this.renderMessageData(
                        '/images/LoginAgent.png',
                        'Campbell',
                        '+91 980-798-8989',
                        ''
                    )}
                    {this.renderMessageData(
                        '/images/LoginAgent.png',
                        'Tracey	Simpson',
                        '+91 980-798-8989',
                        ''
                    )}
                </div>
                <div className='p-3'>
                    <div className='box-title'>
                        <InsightTitle>
                            channels
                        </InsightTitle>
                        <span class="material-symbols-outlined">
                            add
                        </span>
                    </div>
                </div>
                <div style={{ height: '200px', overflowY: 'auto' }}>
                    {this.renderMessageData(
                        '/images/LoginAgent.png',
                        'Sales',
                        '',
                        '04'
                    )}
                    {this.renderMessageData(
                        '/images/LoginAgent.png',
                        'MARKETING',
                        '',
                        '04'
                    )}
                </div>
            </InsightRowData>
        )
    }
}

export default ContactLeftPartTheme


// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/ContactLeftPartTheme.js